/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Exterior_ColorInputs */

const en_field_exterior_color = /** @type {(inputs: Field_Exterior_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exterior Color`)
};

const es_field_exterior_color = /** @type {(inputs: Field_Exterior_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color exterior`)
};

const fr_field_exterior_color = /** @type {(inputs: Field_Exterior_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couleur extérieure`)
};

const de_field_exterior_color = /** @type {(inputs: Field_Exterior_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Außenfarbe`)
};

const ja_field_exterior_color = /** @type {(inputs: Field_Exterior_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外装色`)
};

const zh_field_exterior_color = /** @type {(inputs: Field_Exterior_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外观颜色`)
};

const ar_field_exterior_color = /** @type {(inputs: Field_Exterior_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اللون الخارجي`)
};

const id_field_exterior_color = /** @type {(inputs: Field_Exterior_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warna Eksterior`)
};

const it_field_exterior_color = /** @type {(inputs: Field_Exterior_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colore Esterno`)
};

const ru_field_exterior_color = /** @type {(inputs: Field_Exterior_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цвет кузова/внешний`)
};

const pt_field_exterior_color = /** @type {(inputs: Field_Exterior_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cor Exterior`)
};

const ko_field_exterior_color = /** @type {(inputs: Field_Exterior_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`외부 색상`)
};

/**
* | output |
* | --- |
* | "Exterior Color" |
*
* @param {Field_Exterior_ColorInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_exterior_color = /** @type {((inputs?: Field_Exterior_ColorInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Exterior_ColorInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_exterior_color(inputs)
	if (locale === "es") return es_field_exterior_color(inputs)
	if (locale === "fr") return fr_field_exterior_color(inputs)
	if (locale === "de") return de_field_exterior_color(inputs)
	if (locale === "ja") return ja_field_exterior_color(inputs)
	if (locale === "zh") return zh_field_exterior_color(inputs)
	if (locale === "ar") return ar_field_exterior_color(inputs)
	if (locale === "id") return id_field_exterior_color(inputs)
	if (locale === "it") return it_field_exterior_color(inputs)
	if (locale === "ru") return ru_field_exterior_color(inputs)
	if (locale === "pt") return pt_field_exterior_color(inputs)
	return ko_field_exterior_color(inputs)
});